export const Routes = {
  WEBSITE: 'company-info-url',
  INFO: 'company-info-company',
  ORIGIN: 'company-info-origin',
  INDUSTRY: 'company-info-industry',
  DESCRIPTION: 'company-info-description',
  SCRAPE: 'company-info-url-scrape',
  SUCCESS: 'company-info-success',
}
